import { PropTypes } from 'prop-types';
import React from 'react';
import PhoneInput from 'react-phone-input-2';
import styled, { css } from 'styled-components';
import 'react-phone-input-2/lib/style.css';
import useThemePicker from '~/hooks/use-theme-picker';

const arrowCss = css`
  border: unset;
  content: ${props =>
    props.currentTheme === 'light'
      ? `url(${require('~/assets/graphics/chevron-down.svg')})`
      : `url(${require('~/assets/graphics/chevron-down-white.svg')})`};
  display: inline-block;
  width: 16px;
  height: 16px;
  position: absolute;
  top: 0px;
`;

const PhoneInputWrapper = styled.div`
  .react-tel-input {
    width: 100%;
    height: 32px;
    .form-control {
      width: 100%;
      height: 32px;
      border: 1px solid var(--neutral-a7);
      background-color: var(--neutral-1);
      color: var(--neutral-a9);
    }
    .form-control.invalid-number {
      border: 1px solid var(--error-11);
      background-color: var(--neutral-1);
      :focus {
        background-color: var(--neutral-1);
      }
    }
    .flag-dropdown {
      border: 1px solid var(--neutral-a7);
      background-color: var(--neutral-1);
      border-right: none;
      .arrow {
        ${arrowCss}
      }
      .arrow.up {
        ${arrowCss}
        transform: rotate(180deg);
      }
      .selected-flag {
        background-color: var(--neutral-1);
        :hover,
        :focus,
        :target,
        :active {
          background-color: var(--neutral-1);
        }
      }
    }
    .flag-dropdown.open {
      background-color: var(--neutral-1);
      .country-list {
        position: fixed;
        background-color: var(--neutral-1);
        .country:hover {
          background-color: var(--neutral-a2);
        }
        .country.highlight {
          background-color: var(--neutral-a3);
        }
      }
    }
    .flag-dropdown.invalid-number {
      border: 1px solid var(--error-11);
      border-right: unset;
    }
  }
`;

function PhoneInputEl({ defaultCountry, placeholder, value, onChange, isValid }) {
  const { theme: currentTheme } = useThemePicker();
  return (
    <PhoneInputWrapper currentTheme={currentTheme}>
      <PhoneInput
        country={defaultCountry}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        isValid={isValid}
        enableLongNumbers
      />
    </PhoneInputWrapper>
  );
}

PhoneInputEl.propTypes = {
  defaultCountry: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  isValid: PropTypes.func,
  error: PropTypes.string,
};

export default PhoneInputEl;
